import React from "react";
import Main from "../../components/layout/Main";

function CompliancePage() {
  return (
    <Main>
      <section>
        <div className="compliance-main-div">
          {/* Heading */}
          <div className="compliance-heading-div">
            <h1>Compliance & Guidelines</h1>
            <p>
              Please review our community compliance rules and guidelines before
              participating in tournaments or streaming on our platform.
            </p>
          </div>

          {/* Compliance Sections */}
          <div className="compliance-section">
            <h2>Community Guidelines</h2>
            <ul>
              <li>Respect all players, organizers, and staff members.</li>
              <li>
                Hate speech, harassment, or offensive content is strictly
                prohibited.
              </li>
              <li>Keep the chat and gameplay environment friendly.</li>
            </ul>
          </div>

          <div className="compliance-section">
            <h2>Fair Play & Security</h2>
            <ul>
              <li>
                Cheating, exploiting bugs, or using third-party hacks will
                result in a permanent ban.
              </li>
              <li>
                Multi-accounting or identity fraud is strictly prohibited.
              </li>
              <li>
                Players must report suspicious activity immediately to support.
              </li>
            </ul>
          </div>

          <div className="compliance-section">
            <h2>Streaming & Content Rules</h2>
            <ul>
              <li>
                Streams must follow platform guidelines and avoid inappropriate
                content.
              </li>
              <li>
                Music or media used must comply with copyright laws.
              </li>
              <li>
                Content creators should disclose sponsorships or promotions.
              </li>
            </ul>
          </div>

          <div className="compliance-section">
            <h2>Data & Privacy</h2>
            <ul>
              <li>Your account details must remain confidential.</li>
              <li>
                We do not share your personal information with third parties
                without consent.
              </li>
              <li>
                Always enable 2FA (Two-Factor Authentication) for security.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </Main>
  );
}

export default CompliancePage;
